module.exports = __webpack_public_path__ + "static/sainsburys-card-e3879525d38b504f8d36dc07dc59a4d9.png";